(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vd-journey-reader"] && !Shopify.designMode) return;
  try {
    (() => {
    const formatPageHeading = () => {
      const heading = document.querySelector('.main-page-title, h1.page-title');
      if (!heading || !heading.textContent.includes('|')) return;

      const lines = heading.textContent
        .split('|')
        .map((line) => line.trim())
        .filter(Boolean);

      if (lines.length < 2) return;

      heading.replaceChildren();
      lines.forEach((line, index) => {
        if (index > 0) heading.append(document.createElement('br'));
        heading.append(document.createTextNode(line));
      });
    };

    const initAll = () => {
      formatPageHeading();
      document.querySelectorAll('[data-vd-journey]:not([data-vd-ready])').forEach(initJourney);
    };

    const initJourney = (root) => {
      root.setAttribute('data-vd-ready', 'true');

      const apiBase = root.dataset.apiBase || 'https://www.completemind.com/vd-api/journey';
      const endpoint = root.dataset.endpoint;
      const seasonalEndpoint = root.dataset.seasonalEndpoint || 'https://www.completemind.com/vd-api/seasonal-introductions.ashx';
      const lifeLessonsEndpoint = root.dataset.lifeLessonsEndpoint || 'https://www.completemind.com/vd-api/life-lessons.ashx';
      const journeyId = root.dataset.journeyId || 'journey-001';
      const startDate = root.dataset.startDate || '';
      const pageUrl = new URL(window.location.href);
      const requestedWeek = parseWeek(pageUrl.searchParams.get('uge'));

      const overviewPanel = root.querySelector('.vd-journey__overview');
      const status = root.querySelector('[data-vd-status]');
      const errorBox = root.querySelector('[data-vd-error]');
      const reader = root.querySelector('[data-vd-reader]');
      const lifeboatWrap = root.querySelector('[data-vd-lifeboat-wrap]');

      if (requestedWeek && lifeboatWrap) {
        lifeboatWrap.hidden = false;
        initLifeboat(root);
      } else if (lifeboatWrap) {
        lifeboatWrap.hidden = true;
      }

      const makePageUrl = (weekNumber) => {
        const url = new URL(window.location.href);
        if (weekNumber) {
          url.searchParams.set('uge', String(weekNumber));
        } else {
          url.searchParams.delete('uge');
        }
        url.hash = '';
        return url.toString();
      };

      if (requestedWeek) {
        if (overviewPanel) overviewPanel.hidden = true;
      } else {
        if (overviewPanel) overviewPanel.hidden = false;
      }

      const updateGrid = (currentWeek, selectedWeek) => {
        root.querySelectorAll('[data-vd-week]').forEach((weekLink) => {
          const weekNumber = Number(weekLink.dataset.vdWeek);
          const unlocked = weekNumber <= currentWeek;
          const isCompleted = weekNumber < currentWeek;
          const isCurrent = weekNumber === currentWeek;
          const isNext = currentWeek < 52 && weekNumber === currentWeek + 1;
          const isSelected = weekNumber === selectedWeek;
          const lifeLessonNumber = Number(weekLink.dataset.vdLifeLessonNumber || 0);
          const lifeLessonLabel = lifeLessonNumber
            ? `, individuel bonus: Naturens spejl ${lifeLessonNumber}`
            : '';

          weekLink.classList.toggle('is-unlocked', unlocked);
          weekLink.classList.toggle('is-locked', !unlocked);
          weekLink.classList.toggle('is-completed', isCompleted);
          weekLink.classList.toggle('is-current', isCurrent);
          weekLink.classList.toggle('is-next', isNext);
          weekLink.classList.toggle('is-selected', isSelected);

          if (unlocked) {
            weekLink.href = makePageUrl(weekNumber);
            weekLink.removeAttribute('aria-disabled');
            weekLink.setAttribute(
              'aria-label',
              `Uge ${weekNumber}${lifeLessonLabel}${isCompleted ? ', læst' : ''}${isCurrent ? ', denne uge' : ''}${isSelected ? ', valgt' : ''}`
            );
          } else {
            weekLink.removeAttribute('href');
            weekLink.setAttribute('aria-disabled', 'true');
            weekLink.setAttribute(
              'aria-label',
              `Uge ${weekNumber}${lifeLessonLabel}, ${isNext ? 'næste uge, åbner snart' : 'åbner senere'}`
            );
          }
        });
      };

      const progressText = (currentWeek) => {
        if (currentWeek >= 52) {
          return 'I er nået til uge 52. Hele rejsen er åbnet.';
        }

        return `I er nået til uge ${currentWeek}.`;
      };

      const renderParagraphs = (container, text) => {
        container.replaceChildren();
        const value = typeof text === 'string' ? text.trim() : '';
        if (!value) return;

        value.split(/\n\s*\n/).forEach((paragraphText) => {
          const paragraph = document.createElement('p');
          paragraph.textContent = paragraphText.trim();
          container.appendChild(paragraph);
        });
      };

      const setText = (selector, value) => {
        const element = root.querySelector(selector);
        if (element) element.textContent = value || '';
      };



const loadSinceLast = async (weekNumber) => {
  const box = root.querySelector('[data-vd-since-last]');
  const questionElement = root.querySelector(
    '[data-vd-since-last-question]'
  );

  if (!box || !questionElement) return;

  /*
    Uge 1:
    Ingen "Siden sidst"

    Uge 2:
    index 0

    Uge 3:
    index 1

    ...

    Uge 52:
    index 50
  */
  if (weekNumber <= 1) {
    box.hidden = true;
    questionElement.textContent = '';
    return;
  }

  const index = weekNumber - 2;

  box.hidden = true;
  questionElement.textContent = '';

  try {
    const apiUrl =
      'https://www.completemind.com/vd-api/vd-siden-sidst.ashx?index=' +
      encodeURIComponent(index);

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Kunne ikke hente Siden sidst-spørgsmålet.');
    }

    const data = await response.json();

    if (data && data.question) {
      questionElement.textContent = data.question;
      box.hidden = false;
    }
  } catch (error) {
    console.error(
      'Vores Dialog – Siden sidst:',
      error
    );

    box.hidden = true;
  }
};



      const loadSeasonalIntroduction = async (weekNumber, currentDate) => {
        if (!seasonalEndpoint || weekNumber < 1) return '';

        const apiUrl = new URL(seasonalEndpoint, window.location.origin);
        apiUrl.searchParams.set('week', String(weekNumber));
        if (currentDate) apiUrl.searchParams.set('date', currentDate);

        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 5000);

        try {
          const response = await fetch(apiUrl.toString(), {
            method: 'GET',
            headers: { Accept: 'application/json' },
            credentials: apiUrl.origin === window.location.origin ? 'same-origin' : 'omit',
            cache: 'no-store',
            signal: controller.signal
          });

          const data = await response.json().catch(() => ({}));
          if (!response.ok || typeof data.text !== 'string') {
            throw new Error(data.message || 'Kunne ikke hente årstidsindledningen.');
          }

          return data.text.trim();
        } catch (error) {
          console.error('Vores Dialog – årstidsindledning:', error);
          return '';
        } finally {
          window.clearTimeout(timeoutId);
        }
      };


      const loadLifeLesson = async (weekNumber) => {
        const isBonusWeek = weekNumber >= 4 && weekNumber <= 48 && weekNumber % 4 === 0;
        if (!lifeLessonsEndpoint || !isBonusWeek) return null;

        const apiUrl = new URL(lifeLessonsEndpoint, window.location.origin);
        apiUrl.searchParams.set('week', String(weekNumber));

        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 5000);

        try {
          const response = await fetch(apiUrl.toString(), {
            method: 'GET',
            headers: { Accept: 'application/json' },
            credentials: apiUrl.origin === window.location.origin ? 'same-origin' : 'omit',
            cache: 'no-store',
            signal: controller.signal
          });

          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            throw new Error(data.message || 'Kunne ikke hente livslektionen.');
          }

          return data.hasBonus && data.lesson ? data.lesson : null;
        } catch (error) {
          console.error('Vores Dialog – livslektion:', error);
          return null;
        } finally {
          window.clearTimeout(timeoutId);
        }
      };


      const renderLifeLesson = (lesson) => {
        const box = root.querySelector('[data-vd-life-lesson]');
        if (!box) return;

        box.hidden = true;
        if (!lesson || !lesson.title) return;

        const lessonNumber = Number(lesson.number || 0);
        setText(
          '[data-vd-life-lesson-eyebrow]',
          lessonNumber ? `Naturens spejl · livslektion ${lessonNumber} af 12` : 'Naturens spejl'
        );
        setText('[data-vd-life-lesson-title]', lesson.title);
        setText('[data-vd-life-lesson-summary]', lesson.summary);
        setText('[data-vd-life-lesson-reflection]', lesson.reflection);

        const lessonParagraphs = Array.isArray(lesson.paragraphs)
          ? lesson.paragraphs.filter((paragraph) => typeof paragraph === 'string').join('\n\n')
          : '';
        renderParagraphs(root.querySelector('[data-vd-life-lesson-body]'), lessonParagraphs);
        renderParagraphs(root.querySelector('[data-vd-life-lesson-invitation]'), lesson.invitation || '');

        box.hidden = false;
      };



      const renderReader = async (data) => {
        const selectedWeek = Number(data.selectedWeek || requestedWeek || data.weekNumber || 0);

        const [seasonalIntroduction, , lifeLesson] = await Promise.all([
          loadSeasonalIntroduction(selectedWeek, data.currentDate),
          loadSinceLast(selectedWeek),
          loadLifeLesson(selectedWeek)
        ]);

        setText('[data-vd-phase]', data.phase);
        setText('[data-vd-week-kicker]', `Uge ${selectedWeek} af ${data.totalWeeks || 52}`);
        setText('[data-vd-title]', data.title);

        const introductionText = [seasonalIntroduction, data.introduction?.week]
          .map((part) => (part || '').trim())
          .filter(Boolean)
          .join('\n\n');
        renderParagraphs(root.querySelector('[data-vd-introduction]'), introductionText);

        const calendar = data.introduction?.calendar;
        const calendarBox = root.querySelector('[data-vd-calendar]');
        if (calendar) {
          setText('[data-vd-calendar-title]', calendar.title || calendar.Title || '');
          renderParagraphs(root.querySelector('[data-vd-calendar-text]'), calendar.text || calendar.Text || '');
          calendarBox.hidden = false;
        } else {
          calendarBox.hidden = true;
        }

        renderParagraphs(root.querySelector('[data-vd-main-text]'), data.mainText || '');
        renderLifeLesson(lifeLesson);
        setText('[data-vd-question]', data.question);
        setText('[data-vd-exercise-title]', data.exercise?.title);
        renderParagraphs(root.querySelector('[data-vd-exercise]'), data.exercise?.instructions || '');
        renderParagraphs(root.querySelector('[data-vd-purpose]'), data.exercise?.purpose || '');
        renderParagraphs(root.querySelector('[data-vd-invitation]'), data.invitation?.text || '');

        const previous = root.querySelector('[data-vd-previous]');
        const next = root.querySelector('[data-vd-next]');
        const overview = root.querySelector('[data-vd-overview]');

        if (data.navigation?.previousWeek) {
          previous.href = makePageUrl(data.navigation.previousWeek);
          previous.hidden = false;
        } else {
          previous.hidden = true;
        }

        if (data.navigation?.nextWeek) {
          next.href = makePageUrl(data.navigation.nextWeek);
          next.hidden = false;
        } else {
          next.hidden = true;
        }

        overview.href = makePageUrl(null);
        reader.hidden = false;
        document.title = `Uge ${selectedWeek}: ${data.title} – ${data.journeyName || 'Vores Dialog'}`;
      };

      const showError = (message) => {
        errorBox.textContent = message || 'Ugens tekst kunne ikke hentes.';
        errorBox.hidden = false;
        reader.hidden = true;
      };

      const load = async () => {
        if (!endpoint) {
          showError('Der mangler et endpoint til rejsen.');
          return;
        }

        const normalizedBase = apiBase.replace(/\/+$/, '');
        const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
        const apiUrl = new URL(`${normalizedBase}${normalizedEndpoint}`);
        apiUrl.searchParams.set('journeyId', journeyId);
        if (requestedWeek) apiUrl.searchParams.set('week', String(requestedWeek));
        if (startDate) apiUrl.searchParams.set('startDate', startDate);

        try {
          const response = await fetch(apiUrl.toString(), {
            method: 'GET',
            headers: { Accept: 'application/json' },
            credentials: apiUrl.origin === window.location.origin ? 'same-origin' : 'omit'
          });

          const data = await response.json().catch(() => ({}));
          const currentWeek = Number(data.currentWeek || data.unlockedThroughWeek || data.weekNumber || 0);
          if (currentWeek > 0) updateGrid(currentWeek, requestedWeek || 0);

          if (!response.ok) {
            if (data.error === 'week_locked' && currentWeek > 0) {
              status.textContent = progressText(currentWeek);
            }
            showError(data.message || 'Ugens tekst kunne ikke hentes.');
            return;
          }

          errorBox.hidden = true;
          status.textContent = progressText(currentWeek);

          if (requestedWeek) {
            await renderReader(data);
            window.requestAnimationFrame(() => {
              reader.scrollIntoView({ behavior: 'auto', block: 'start' });
            });
          } else {
            reader.hidden = true;
          }
        } catch (error) {
          showError('Der opstod en forbindelsefejl, mens rejsen blev hentet.');
        }
      };

      const printButton = root.querySelector('[data-vd-print]');
      if (printButton) {
        printButton.addEventListener('click', () => window.print());
      }

      load();
    };

    const initLifeboat = (root) => {
      if (root.dataset.vdLifeboatReady === 'true') return;

      const openButton = root.querySelector('[data-vd-lifeboat-open]');
      const closeButton = root.querySelector('[data-vd-lifeboat-close]');
      const overlay = root.querySelector('[data-vd-lifeboat-overlay]');
      const drawer = root.querySelector('[data-vd-lifeboat-drawer]');

      if (!openButton || !closeButton || !overlay || !drawer) return;
      root.dataset.vdLifeboatReady = 'true';

      let previousActiveElement = null;
      let previousOverflow = '';
      let hideTimer = null;

      const openDrawer = () => {
        if (hideTimer) {
          window.clearTimeout(hideTimer);
          hideTimer = null;
        }

        previousActiveElement = document.activeElement;
        drawer.hidden = false;
        overlay.hidden = false;
        drawer.getBoundingClientRect();

        window.requestAnimationFrame(() => {
          root.classList.add('is-lifeboat-open');
        });

        openButton.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        drawer.setAttribute('role', 'dialog');
        drawer.setAttribute('aria-modal', 'true');
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        window.setTimeout(() => closeButton.focus(), 0);
      };

      const closeDrawer = () => {
        root.classList.remove('is-lifeboat-open');
        openButton.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = previousOverflow;

        hideTimer = window.setTimeout(() => {
          drawer.hidden = true;
          overlay.hidden = true;
          hideTimer = null;
        }, 280);

        if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
          previousActiveElement.focus();
        }
      };

      openButton.addEventListener('click', openDrawer);
      closeButton.addEventListener('click', closeDrawer);
      overlay.addEventListener('click', closeDrawer);

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && root.classList.contains('is-lifeboat-open')) {
          closeDrawer();
        }
      });
    };

    const parseWeek = (value) => {
      if (!/^\d{1,2}$/.test(value || '')) return 0;
      const week = Number(value);
      return week >= 1 && week <= 52 ? week : 0;
    };

    window.addEventListener('beforeprint', () => document.body.classList.add('vd-journey-printing'));
    window.addEventListener('afterprint', () => document.body.classList.remove('vd-journey-printing'));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
